module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABLMAAAABCAYAAAAlz+wPAAAAAXNSR0IArs4c6QAAADdJREFUWAnt0EEVACAIBbBPER9NpbnU8LBFWJ3um5cJBgwYMGDAgAEDBgwYMGDAgAEDBn4eqMwCd6kC3yJT4kIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expanded-project--col-line-2.png
// module id = 466
// module chunks = 0